module.exports = __webpack_public_path__ + "img/banner_industry.b3d87200.png";